import { render } from "./DirectionTab.vue?vue&type=template&id=59054e32"
import script from "./DirectionTab.vue?vue&type=script&lang=js"
export * from "./DirectionTab.vue?vue&type=script&lang=js"

import "./DirectionTab.vue?vue&type=style&index=0&id=59054e32&lang=scss"
script.render = render

export default script